import { startConfirmEmailForCandidate } from "./SendEmailConfirmationForCandidate";
import { addCourseToCandidate } from "./addCourseToCandidate";
import { addEducationToCandidate } from "./addEducationToCandidate";
import { addExperienceToCandidate } from "./addExperienceToCandidate";
import { addGeoWishFromCandidate } from "./addGeoWishToCandidate";
import { addKnowledgeToCandidate } from "./addKnowledgeToCandidate";
import { addPositionWishToCandidate } from "./addPositionWishToCandidate";
import { applyWithProfile } from "./applyWithProfile";
import { checkEmailVerification } from "./checkEmailVerificationForCandidate";
import { checkWasDeleteRequested } from "./checkWasDeleteRequested";
import { deleteMe } from "./deleteMe";
import { deleteProfilePicture } from "./deleteProfilePicture";
import { editCourseForCandidate } from "./editCourseForCandidate";
import { editEducationForCandidate } from "./editEducationForCandidate";
import { editEmailForCandidate } from "./editEmailForCandidate";
import { editExperienceForCandidate } from "./editExperienceForCandidate";
import { editKnowledgeForCandidate } from "./editKnowledgeForCandidate";
import { editPositionWishForCandidate } from "./editPositionWishForCandidate";
import { endConsentForCandidate } from "./endConsent";
import { getAllConsents } from "./getConsentAllConsents";
import { getConsentForCandidate } from "./getConsentSummaryForCandidate";
import { getCoursesForCandidate } from "./getCoursesForCandidate";
import { getDetailsForCandidate } from "./getDetailsForCandidate";
import { getEducationForCandidate } from "./getEducationForCandidate";
import { getExperienceForCandidate } from "./getExperienceForCandidate";
import { getGeoWishes } from "./getGeoWishes";
import { getKnowledgeForCandidate } from "./getKnowledgeForCandidate";
import { getPositionWishes } from "./getPositionWishes";
import { getPositionWishesFromCandidateObj } from "./getPositionWishesFromCandidateObj";
import { getPrivacyStatement } from "./getPrivacyStatement";
import { getProfilePictureUrl } from "./getProfilePictureUrl";
import { isCandidateAttachedToCase } from "./isCandidateAttachedToCase";
import { detachCandidateFromCase } from "./detachCandidateFromCase";
import { removeCourseFromCandidate } from "./removeCourseFromCandidate";
import { removeEducationFromCandidate } from "./removeEducationFromCandidate";
import { removeExperienceFromCandidate } from "./removeExperienceFromCandidate";
import { removeGeoWishFromCandidate } from "./removeGeoWishToCandidate";
import { removeKnowledgeByTypeFromCandidate } from "./removeKnowledgeByTypeFromCandidate";
import { removeKnowledgeFromCandidate } from "./removeKnowledgeFromCandidate";
import { removePositionWishFromCandidate } from "./removePositionWishToCandidate";
import { setGeoWishToCandidate } from "./setGeoWishToCandidate";
import { setKnowledgeForCandidate } from "./setKnowledgeForCandidate";
import { setPositionWishToCandidate } from "./setPositionWishToCandidate";
import { startConsentForCandidate } from "./startConsent";
import { updateCandidate } from "./updateCandidate";
import { uploadProfilePicture } from "./uploadProfilePicture";
import { applyWithoutProfile } from "./applyWithoutProfile";
import { quickConsentCheckForCandidate } from "./quickConsentCheckForCandidate";
import { checkPhoneVerification } from "./checkPhoneVerificationForCandidate";
import { startPhoneVerificationForCandidate } from "./startPhoneVerificationForCandidate";
import { applyWithProfileMultiAttachements } from "./applyWithProfileMultiAttachments";
import { applyWithoutProfileMultiAttachments } from "./applyWithoutProfileMultiAttachments";
import { setCandidateLanguage } from "./setCandidateLanguage";

export const candidateAPI = {
  addCourseToCandidate,
  getCoursesForCandidate,
  removeCourseFromCandidate,
  addEducationToCandidate,
  getEducationForCandidate,
  removeEducationFromCandidate,
  addExperienceToCandidate,
  getExperienceForCandidate,
  removeExperienceFromCandidate,
  addKnowledgeToCandidate,
  getKnowledgeForCandidate,
  removeKnowledgeFromCandidate,
  removeKnowledgeByTypeFromCandidate,
  updateCandidate,
  getDetailsForCandidate,
  addPositionWishToCandidate,
  getProfilePictureUrl,
  deleteProfilePicture,
  uploadProfilePicture,
  removePositionWishFromCandidate,
  editExperienceForCandidate,
  editCourseForCandidate,
  editEducationForCandidate,
  editKnowledgeForCandidate,
  editPositionWishForCandidate,
  applyWithProfile,
  getConsentForCandidate,
  startConsentForCandidate,
  endConsentForCandidate,
  getAllConsents,
  getPrivacyStatement,
  deleteMe,
  checkWasDeleteRequested,
  getPositionWishes,
  getGeoWishes,
  addGeoWishFromCandidate,
  removeGeoWishFromCandidate,
  getPositionWishesFromCandidateObj,
  editEmailForCandidate,
  startConfirmEmailForCandidate,
  checkEmailVerification,
  setGeoWishToCandidate,
  setPositionWishToCandidate,
  setKnowledgeForCandidate,
  setCandidateLanguage,
  isCandidateAttachedToCase,
  detachCandidateFromCase,
  applyWithoutProfile,
  quickConsentCheckForCandidate,
  checkPhoneVerification,
  startPhoneVerificationForCandidate,
  applyWithProfileMultiAttachements,
  applyWithoutProfileMultiAttachments,
};

export type CandidateAPI = typeof candidateAPI;
